<div class="FlightDataInfo-heads">
    <div class="FlightDataInfo-dateFlight">
        <div class="fs-24px fw-regular lh-30px text-am-white">
            <span class="opacity-70">
                {{ "srIrops.dateFlight" | translate }}
            </span>
        </div>
        <div>
            <span class="FlightDataInfo-detail fs-32px fw-medium-x lh-42px text-am-white">
                <span>{{ departureTime | localizedDate:'dd MMM' | titlecase }}</span>
            </span>
        </div>
    </div>
    <div class="FlightDataInfo-separatorLine"></div>
    <div class="FlightDataInfo-flightNumber">
        <div class="fs-24px fw-regular lh-30px text-am-white">
            <span class="opacity-70">
                {{ "srIrops.vuelo" | translate }}
            </span>
        </div>
        <div class="FlightDataInfo-detail fs-32px fw-medium-x lh-42px text-am-white">
            <span>
                {{ flightNumber }}
            </span>
        </div>
    </div>
    <div class="FlightDataInfo-separatorLine"></div>
    <div class="FlightDataInfo-flightNumber">
        <div class="fs-24px fw-regular lh-30px text-am-white">
            <span class="opacity-70">
                {{ "noticeClose.gate" | translate }}
            </span>
        </div>
        <div class="FlightDataInfo-detail fs-32px fw-medium-x lh-42px text-am-white">
            <span>
                {{ gate }}
            </span>
        </div>
    </div>
    <div class="FlightDataInfo-separatorLine"></div>
    <div class="FlightDataInfo-flightNumber" *ngIf="statusIrops != 'Cancelled'">
        <div class="fs-24px fw-regular lh-30px text-am-white">
            <span class="opacity-70">
                {{ "Boarding" | translate }}
            </span>
        </div>
        <div class="FlightDataInfo-detail fs-32px fw-medium-x lh-42px">
            <span>
                {{ boardingTime | date:'HH:mm' }}
            </span>
        </div>
    </div>
    <div class="FlightDataInfo-hourDeparture" *ngIf="statusIrops == 'Cancelled'">
        <div class="fs-24px fw-regular lh-30px text-am-white">
            <span class="opacity-70">
                {{ "srIrops.departure" | translate: { departure: '' } }}
            </span>
        </div>
        <div class="FlightDataInfo-detail fs-32px fw-medium-x lh-42px text-am-white">
            <span>
                {{ departureTime | localizedDate: 'HH:mm' }}
            </span>
        </div>
    </div>
    <div class="FlightDataInfo-separatorLine"></div>
    <div class="FlightDataInfo-hourArrival">
        <div class="fs-24px fw-regular lh-30px text-am-white">
            <span class="opacity-70">
                {{ "srIrops.arrival" | translate: { arrival: '' } }}
            </span>
        </div>
        <div class="FlightDataInfo-detail fs-32px fw-medium-x lh-42px text-am-white">
            <span>
                {{ arrivalTime | localizedDate: 'HH:mm' }}
            </span>
        </div>
    </div>
</div>